import { render, staticRenderFns } from "./user-info.html?vue&type=template&id=c332af20&scoped=true&"
import script from "./user-info.js?vue&type=script&lang=js&"
export * from "./user-info.js?vue&type=script&lang=js&"
import style0 from "./user-info.scss?vue&type=style&index=0&id=c332af20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c332af20",
  null
  
)

export default component.exports